import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate, useLocation } from 'react-router-dom';
import AddComment from './AddComment';

export default function Company_member_Timetrack() {
   const navigate = useNavigate();
   const [listMyTaskArray, setListMyTaskArray] = useState([]);
       const [showHistoryPopup, setShowHistoryPopup] = useState(false);
       const [historyData, setHistoryData] = useState([]);
       const [taskTitle, setTaskTitle] = useState('');
       const [membretype, setMembertype] = useState(false);

       useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
               const userid = localStorage.getItem('selectedComMemberID');
               var obj = {
                   user_id: userid,
               }
               $.ajax({
                   type: 'POST',
                   url: 'getMyTgaskHistory.php',
                   data: obj,
                   cache: false,
                   success: function (result) {
                       var res = result;
                       console.log(res);
                       if (res !== 'fail' && res !== '') {
                           var arr = JSON.parse(res);
                           console.log(arr);
                           setListMyTaskArray(arr)
                       } else {
                           showAlert("Hmm… it looks like no tasks have been assigned to you yet.");
                           $('#norecord').css('display', 'block');
                       }
                   },
               });
           }, []);

             function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    function openHistory(item) {
        setHistoryData(item.timetracking);
        setTaskTitle(item.tsk_name || 'Task History');
        setShowHistoryPopup(true);
       // $('#detailsbox').css('display','block')
    }
    function closeHistory() {
        setShowHistoryPopup(false);
        setHistoryData([]);
    }

    function calculateTotalTime(entries) {
        let totalSeconds = 0;

        entries.forEach(e => {
            const [h, m, s] = e.time_worked.split(':').map(Number);
            totalSeconds += h * 3600 + m * 60 + s;
        });

        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    }
    function retruntolist(){
        navigate('/companymember_list');
    }
  return (
    <div>
      <div className='fullwidth'>
        <section className='mainsection border-bottom'>
            <div className='max-container'>
                 <div className='headpart'>

              <div className='vl_dsh_one_half'>
                <div className='fullwidth topbackBar'>
                  <button className='back_btn' onClick={retruntolist}><i class="ri-arrow-left-line"> Back</i></button>
                </div>
                <p className='top_info' id="pro_info">Company Name<span><i class="ri-arrow-right-line"></i></span><span id="tskname"></span></p>
              </div>
              
            </div>

            </div>
        </section>
        <section className='mainsection'>
            <div className='max-container'>
                <div className='vl_listing_area'>
                        <div className='vl_listing_row'>
                            <div className='vl_listing_cell width20'>
                                <h4 className='prj_name'>Project Name</h4>
                            </div>
                            <div className='vl_listing_cell width20'>
                                <p>Task Name</p>
                            </div>
                            <div className='vl_listing_cell width40'>
                                <p>Task Details</p>
                            </div>


                            <div className='vl_listing_cell width10'>
                                <p>Hours (Worked)</p>
                            </div>
                            <div className='vl_listing_cell width10'>
                                <p>Status</p>
                            </div>
                        </div>
                        <div className='vl_listing_row nodisplay' id="norecord">
                            <h1 className='notice_text'> No Record Found</h1>
                        </div>
                        {listMyTaskArray.map((item, index) => {


                            return (
                                <div className='vl_listing_row' key={index}>
                                    <div className='vl_listing_cell width20'>
                                        <h4 className='prj_name'>{item.proname}</h4>

                                    </div>

                                    <div className='vl_listing_cell width20 hig120 prdetails'>
                                        <p>{item.tsk_name}</p>

                                    </div>

                                    <div className='vl_listing_cell width40'>
                                        <p>{item.tsx_desc}</p>
                                    </div>

                                    <div className='vl_listing_cell width10'>
                                        {item.timetracking.length > 0 ? (
                                            <button onClick={() => openHistory(item)}>
                                                Open History
                                            </button>
                                        ) : (
                                            <span className="no-history-text">No History</span>
                                        )}
                                    </div>

                                    <div className='vl_listing_cell width10'>
                                        <p>{item.tsk_status}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {showHistoryPopup && (
                        <div className="vl_dsh_popup_details" id="detailsbox">
                            <div className="alertbox_hig large">

                                <div className="alertheader">
                                    <h3>{taskTitle} — Work History</h3>
                                </div>

                                <div className="contentarea">

                                    <table className="history-table">
                                        <thead>
                                            <tr>
                                                <th>Date of Work</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                                <th>History</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historyData.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{row.dateofWork}</td>
                                                    <td>{row.start_time}</td>
                                                    <td>{row.end_time}</td>
                                                    <td>{row.time_worked}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="total-hours">
                                        <div>
                                        
                                            Total Working Hours from {historyData[0].dateofWork} to{' '}
                                            {historyData[historyData.length - 1].dateofWork}
                                        :  <span className="highlighttext">{calculateTotalTime(historyData)}</span>
                                        </div>
                                    </div>

                                </div>

                                <div className="alert_btns">
                                    <button onClick={closeHistory}>Close</button>
                                </div>

                            </div>
                        </div>
                    )}
            </div>
        </section>
        <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
      </div>
      {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
    </div>
  )
}
